import {dsColorNew} from "@palette";

const inputBg = {
    '& .MuiOutlinedInput-root': { backgroundColor: dsColorNew.filterInputBg },
    '& .MuiInputBase-root': { backgroundColor: dsColorNew.filterInputBg },
    '& .rs-picker-toggle': { backgroundColor: `${dsColorNew.filterInputBg} !important` },
    '& .rs-picker-cascader .rs-btn': { backgroundColor: `${dsColorNew.filterInputBg} !important` },
    '& .rs-picker-select .rs-btn': { backgroundColor: `${dsColorNew.filterInputBg} !important` },
    '& .rs-picker-default .rs-picker-toggle': { backgroundColor: `${dsColorNew.filterInputBg} !important` },
}


const overrideComponentStyles = () => ({
    // --- Inputs ---
    MuiOutlinedInput: {
        styleOverrides: {
            root: {
                backgroundColor: dsColorNew.filterInputBg,
            }
        }
    },

    // --- Tabs ---
    MuiTabs: {
        styleOverrides: {
            root: {
                borderBottom: `1px solid ${dsColorNew.grayBorder}`,
            },
            indicator: {
                height: 3,
                borderRadius: '3px 3px 0 0',
            }
        }
    },
    MuiTab: {
        styleOverrides: {
            root: {
                fontSize: '0.875rem',
                fontWeight: 500,
                textTransform: 'none',
                '&:hover': {
                    backgroundColor: dsColorNew.hoverBgLight,
                    borderRadius: '8px 8px 0 0',
                },
            }
        }
    },

    // --- Card ---
    MuiCard: {
        styleOverrides: {
            root: {
                borderRadius: 12,
                border: `1px solid ${dsColorNew.grayBorder}`,
                boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
            }
        }
    },
    MuiCardHeader: {
        styleOverrides: {
            root: {
                borderBottom: `1px solid ${dsColorNew.grayBorder}`,
                padding: '14px 20px',
            },
            title: {
                fontSize: '0.875rem',
                fontWeight: 600,
                color: '#111827',
            },
            subheader: {
                fontSize: '0.75rem',
                color: '#6B7280',
            }
        }
    },
    MuiCardContent: {
        styleOverrides: {
            root: {
                padding: '20px',
                '&:last-child': { paddingBottom: '20px' },
            }
        }
    },

    // --- Accordion ---
    MuiAccordion: {
        styleOverrides: {
            root: {
                border: `1px solid ${dsColorNew.grayBorder}`,
                boxShadow: 'none',
                '&:before': { display: 'none' },
                '&.Mui-expanded': { margin: 0 },
            }
        }
    },
    MuiAccordionDetails: {
        styleOverrides: {
            root: {
                padding: '20px',
                ...inputBg,
            }
        }
    },
    MuiAccordionSummary: {
        styleOverrides: {
            root: {
                backgroundColor: dsColorNew.filterInputBg,
                borderBottom: `1px solid ${dsColorNew.grayBorder}`,
                minHeight: 48,
                '&.Mui-expanded': { minHeight: 48 },
            },
            content: {
                '&.Mui-expanded': { margin: '12px 0' },
            }
        }
    },
})

export default overrideComponentStyles
